import React from 'react';
import clsx from 'clsx';

import { Hx } from '@/stories/atoms/Hx/Hx';
import styles from './section.module.css';
import { Grid } from '../Grid/Grid';

export type SectionProps = React.HTMLAttributes<HTMLDivElement> & {
  /** Section title */
  title?: React.ReactNode
  /** Section sub title to be display juste under the title */
  subTitle?: string,
  /** If the se ction is inside a col */
  inner?: boolean,
  /** background color of the section, spread the background inline */
  background?: 'grey-light' | 'brand' | 'dark',
  /** vertical padding */
  padding?: 's' | 'm' | 'l' | 'xl' | '0',
  paddingStart?: 's' | 'm' | 'l' | 'xl' | '0',
  paddingEnd?: 's' | 'm' | 'l' | 'xl' | '0',
  gap?: 's' | 'm' | 'l' | 'xl' | '0',
  className?: string
}

export const Section = ({title, subTitle, padding, paddingStart, paddingEnd, gap, inner, background, className, children, ...props}: SectionProps) => {

  return (
    <div
      className={clsx(
        styles.wrapper,
        inner && styles['inner'],
        paddingStart && styles[`paddingStart-${paddingStart}`],
        paddingEnd && styles[`paddingEnd-${paddingEnd}`],
        background && styles[background],
        className
        )}
        {...(padding || paddingStart || paddingEnd || gap ? {
          style: {
            ...(padding ? {'--section-vertical-padding': `var(--spacing-${padding})`} : {}),
            ...(paddingStart ? {'--section-vertical-paddingStart': `var(--spacing-${paddingStart})`} : {}),
            ...(paddingEnd ? {'--section-vertical-paddingEnd': `var(--spacing-${paddingEnd})`} : {}),
            ...(gap ? {'--gap': `var(--spacing-${gap})`} : {})
          } as React.CSSProperties
        } : {})}
        {...props}
        >
      {title || subTitle ? (
      <Grid nbCols={1}>
        {title ? <Hx headingLevel='h2' styleLevel='h1' className={styles.title}>{title}</Hx> : null}
        {subTitle ? <p className={styles.subTitle}>{subTitle}</p> : null}
      </Grid>
    ) : null}
      {children}
    </div>
  )
};

export type SectionActionProps = React.HTMLAttributes<HTMLDivElement>

export const SectionAction = ({children, ...props}: SectionActionProps) => {
  return (
    <div className={clsx(styles.actions)} {...props}>
      {children}
    </div>
  )
};
